// extracted by mini-css-extract-plugin
export default {"content":"subsidiary_mode_alert-module___content___a521f907","actions":"subsidiary_mode_alert-module___actions___d35c2a69"};